import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getActiveAds } from '../services/adService';

/**
 * Hook to fetch ads for a specific placement
 * @param {String} placement - Ad placement (header, sidebar, footer, etc.)
 * @param {Object} options - Additional options
 * @param {String} options.categoryId - Category ID for targeting
 * @param {Number} options.limit - Maximum number of ads
 * @returns {Object} { ads, loading, error }
 */
export const useAds = (placement, options = {}) => {
  const { region, apiRegion, language } = useLanguage();
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAds = async () => {
      if (!placement) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const params = {
          region: apiRegion || region?.code || 'US',
          language: language || 'en',
          limit: options.limit || 5,
          ...(options.categoryId && { category: options.categoryId })
        };

        const response = await getActiveAds(placement, params);
        
        if (response.success && response.data) {
          setAds(response.data);
        } else {
          setAds([]);
        }
      } catch (err) {
        console.error('Error fetching ads:', err);
        setError(err);
        setAds([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAds();
  }, [placement, apiRegion, region?.code, language, options.categoryId, options.limit]);

  return { ads, loading, error };
};



